import React from "react";
import clsx from "clsx";

import { Theme, useMediaQuery } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import MatchesCount from "components/MatchesCount";
import Breakpoints from "common/breakpoints";
import MatchedRacesList from "../../MatchedRacesList";
import useStyles from "./styles";

interface IProps {
  matchedRaces?: racehorse360.IRaceCondition[];
  onOpenMatchedRacesPopover: () => void;
}

const MatchedRaces = React.memo((props: IProps) => {
  const { matchedRaces = [], onOpenMatchedRacesPopover } = props;
  const classes = useStyles();

  const isScreenSX720 = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(Breakpoints.SX_720)
  );

  const matchedRacesPreview = matchedRaces.filter(
    (race: racehorse360.IRaceCondition, index: number) => index < 5
  );

  return (
    <div>
      <div className={classes.header}>
        <MatchesCount
          customStyles={{ marginRight: 8 }}
          matchedHorsesCount={matchedRaces.length}
        />
        <span
          className={clsx(classes.headerTitle, {
            ["hasMatches"]: matchedRaces.length
          })}
        >
          Race Conditions Matches
        </span>
      </div>

      <div className={classes.content}>
        <MatchedRacesList
          races={matchedRacesPreview}
          smallWidthIconColumn={!isScreenSX720}
        />
        {matchedRaces.length > 5 && (
          <Button
            className={classes.seeAllButton}
            onClick={onOpenMatchedRacesPopover}
          >
            See All Matching Races
          </Button>
        )}
      </div>
    </div>
  );
});

export default MatchedRaces;
